module.exports = __webpack_public_path__ + "static/media/nudeln_pesto.6c741d9a.png";